import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const DeleteMasterModal = ({
    t,
    showModal,
    closeModal,
    onDelete,
    title = 'Delete Item',
    message = 'Are you sure you want to delete this item?',
    imageSrc = '/asset-images/deleteiconmodal.png',
}) => {
    return (
        <Modal show={showModal} onHide={closeModal} centered>
            <Modal.Header closeButton style={{ backgroundColor: '#D9E9FF' }}>
                <Modal.Title>{t(title)}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-center">
                <img src={imageSrc} alt="Delete" className="img-fluid" style={{ maxWidth: '100px' }} />
                <p className="mt-3">{t(message)}</p>
                <div className="d-flex justify-content-center gap-2">
                    <Button variant="secondary" onClick={closeModal} style={{ width: '100px', borderRadius: '0' }}>
                        {t('No')}
                    </Button>
                    <Button
                        variant="outline-danger"
                        onClick={onDelete}
                        style={{ width: '100px', borderRadius: '0', border: '2px solid red' }}>
                        {t('Yes')}
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default DeleteMasterModal;
